export const ASSIGN_TOKENS = 'ASSIGN_TOKENS';
export const LOGOUT = 'LOGOUT';
export const REFRESH_AUTH_TOKEN = 'REFRESH_AUTH_TOKEN';
export const SET_USER_ERROR = 'SET_USER_ERROR';
export const UPDATE_TOKENS = 'UPDATE_TOKENS';
